var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 242.781,
    y: 74,
    width: 26.2392,
    height: 76.7247,
    rx: 13.1196,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 153.549,
    y: 103.453,
    width: 26.2392,
    height: 76.7247,
    rx: 13.1196,
    transform: "rotate(-30 153.549 103.453)",
    fill: "white",
    fillOpacity: 0.087
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 91.7295,
    y: 176.86,
    width: 26.2392,
    height: 76.7247,
    rx: 13.1196,
    transform: "rotate(-60 91.7295 176.86)",
    fill: "white",
    fillOpacity: 0.17
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 269.021,
    width: 26.2392,
    height: 76.7247,
    rx: 13.1196,
    transform: "rotate(-90 74 269.021)",
    fill: "white",
    fillOpacity: 0.253
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 104.849,
    y: 361.243,
    width: 26.2392,
    height: 76.7247,
    rx: 13.1196,
    transform: "rotate(-120 104.849 361.243)",
    fill: "white",
    fillOpacity: 0.336
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 175.441,
    y: 420.133,
    width: 26.2392,
    height: 76.7247,
    rx: 13.1196,
    transform: "rotate(-150 175.441 420.133)",
    fill: "white",
    fillOpacity: 0.419
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 268.312,
    y: 437.803,
    width: 26.2392,
    height: 76.7247,
    rx: 13.1196,
    transform: "rotate(180 268.312 437.803)",
    fill: "white",
    fillOpacity: 0.502
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 357.698,
    y: 407.013,
    width: 26.2392,
    height: 76.7247,
    rx: 13.1196,
    transform: "rotate(150 357.698 407.013)",
    fill: "white",
    fillOpacity: 0.585
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 420.841,
    y: 335.683,
    width: 26.2392,
    height: 76.7247,
    rx: 13.1196,
    transform: "rotate(120 420.841 335.683)",
    fill: "white",
    fillOpacity: 0.668
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 437.094,
    y: 242.782,
    width: 26.2392,
    height: 76.7247,
    rx: 13.1196,
    transform: "rotate(90 437.094 242.782)",
    fill: "white",
    fillOpacity: 0.751
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 406.305,
    y: 151.299,
    width: 26.2392,
    height: 76.7247,
    rx: 13.1196,
    transform: "rotate(60 406.305 151.299)",
    fill: "white",
    fillOpacity: 0.834
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 337.102,
    y: 92.4384,
    width: 26.2392,
    height: 76.7247,
    rx: 13.1196,
    transform: "rotate(30 337.102 92.4384)",
    fill: "white",
    fillOpacity: 0.917
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.582b3ae6f7a29e3f6178c0ea619ae09a.svg";
export { ForwardRef as ReactComponent };